import { render, staticRenderFns } from "./FiltrosBase.vue?vue&type=template&id=5a25cfaa&scoped=true"
import script from "./FiltrosBase.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FiltrosBase.vue?vue&type=style&index=0&id=5a25cfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a25cfaa",
  null
  
)

export default component.exports